import { MantineThemeOverride } from '@mantine/core';
import storage from '@/utils/storage';
import { defaultColors, getColorTheme } from '@/utils/theme';

export const theme: MantineThemeOverride = {
  globalStyles: () => ({
    body: {},
  }),
  colors: {
    primary: getColorTheme(storage.getItem('config') ?? defaultColors),
    gray: [
      '#f7f7f7',
      '#F1F3F5',
      '#E9ECEF',
      '#DEE2E6',
      '#CED4DA',
      '#ADB5BD',
      '#666666',
      '#495057',
      '#343A40',
      '#212529',
    ],
    dark: [
      '#F8F8F8',
      '#999999',
      '#7F7F7F',
      '#5B5B5B',
      '#414141',
      '#2E2E2E',
      '#212121',
      '#141414',
      '#0C0C0C',
      '#070707',
    ],
    green: [
      '#f4f9eb',
      '#deeec4',
      '#c8e39d',
      '#bcdd89',
      '#b1d875',
      '#a6d261',
      '#9bcd4e',
      '#90c73a',
      '#739f2e',
      '#567723',
    ],
    red: [
      '#ffdcda',
      '#ffcbc8',
      '#ffa8a4',
      '#ff9791',
      '#ff857f',
      '#ff746d',
      '#ff625a',
      '#ff5148',
      '#e64941',
      '#99312b',
    ],
    yellow: [
      '#fff5d1',
      '#fff0ba',
      '#ffeba3',
      '#ffe276',
      '#ffdd5f',
      '#ffd848',
      '#ffd331',
      '#ffce1a',
      '#e6b917',
      '#b39012',
    ],
  },
  primaryColor: 'primary',
  fontFamily: 'HKGrotesk, sans-serif',
  headings: {
    fontFamily: 'HKGrotesk, sans-serif',
    sizes: {
      h1: { fontSize: '4rem' },
      h2: { fontSize: '3rem' },
      h3: { fontSize: '2.25rem' },
      h4: { fontSize: '1.5rem' },
      h5: { fontSize: '1.25rem' },
      h6: { fontSize: '1rem' },
    },
  },
  breakpoints: {
    xs: '31.25em',
    sm: '50em',
    md: '62.5em',
    lg: '75em',
    xl: '87.5em',
  },
  spacing: { xs: '0.5rem', sm: '0.75rem', md: '1rem', lg: '1.5rem', xl: '2.5rem' },
  components: {
    Container: {
      defaultProps: {
        sizes: {
          xs: '30rem',
          sm: '48rem',
          md: '62rem',
          lg: '80rem',
          xl: '90rem',
        },
      },
    },
  },
  fontSizes: {
    xs: '0.625rem', // 10px
    sm: '0.75rem', // 12px
    md: '0.875rem', // 14px
    base: '1rem',
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
  },
};
